import axiosClient from 'api/config/axiosClient';

const externalLink = ({ externalUrl, productId, productName }) => {
  const url = `v1/logging/external-link-clicks`;
  return axiosClient.post(url, {
    url: externalUrl,
    pageTitle: document.title,
    productId: productId,
    productName: productName,
  });
};

export { externalLink };
